import { apiFetch } from "./config.js";
/** Every question HP Genie answered, newest first (admins only). */
export async function listQuestionLog(params = {}) {
    const q = new URLSearchParams();
    if (params.since)
        q.set("since", params.since);
    if (params.until)
        q.set("until", params.until);
    if (params.limit)
        q.set("limit", String(params.limit));
    if (params.withTrace)
        q.set("with_trace", "true");
    const qs = q.toString();
    return apiFetch(`/regulation/chats/log${qs ? `?${qs}` : ""}`);
}
/** One logged question with its whole research trace (admins only). */
export async function getQuestionLogEntry(id) {
    return apiFetch(`/regulation/chats/log/${id}`);
}
